import { RouteManager } from '@goodt-wcore/managers';
import { isEmpty } from 'lodash';

/**
 * @return {{ addRouteQueryParams: (params: Record<string, any>) => {} }}
 */
export const useRouteQueryManager = () => {
    const routeManager = RouteManager.instance;
    
    const addRouteQueryParams = (params) => {
        if (routeManager.route == null) {
            return;
        }
        
        if (isEmpty(params)) {
            return;
        }
        
        const { path, query } = routeManager.route;
        const newQuery = Object.fromEntries(
            Object.entries({ ...query, ...params }).filter(([_, value]) => value != null)
        );
        
        routeManager.navigate({ path, query: newQuery });
    };
    
    return { addRouteQueryParams };
};
